import SportsBarIcon from '@mui/icons-material/SportsBar'
import {
  Box,
  Card as MuiCard,
  Grid,
  Paper,
  Typography
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useThemeMode } from '../../../theme'
import { BartenderIcon, NoData, TranslatableTypography } from '../widgets'
import { notDefined } from '../../../utils'

const makeStyles = (palette) => ({
  header: {
    grid: { px: 2, pt: 1, pb: 1, alignItems: 'center', maxWidth: '700px', margin: '0 auto' },
    iconCol: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
    contentCol: { display: 'flex', flexDirection: 'column', gap: 0.5, justifyContent: 'center' },
    title: { color: palette.headerColor, lineHeight: 1.2 }
  },
  list: { px: 1, pt: 1, pb: 2, maxWidth: '700px', margin: '0 auto' },
  card: {
    leftCol: {
      background: palette.headerBrightColor,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      py: 1.5,
      px: 0.5,
      minHeight: '100%'
    },
    leftIconWrapper: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%'
    },
    leftIcon: { color: palette.headerTransparentThinColor, width: '50%', height: 'auto' },
    leftNumber: {
      position: 'absolute',
      color: 'white',
      fontWeight: 800,
      fontSize: '2rem',
      lineHeight: 1
    },
    rightCol: { display: 'flex', flexDirection: 'column' },
    bodyBox: { px: 1.5, pt: 1, pb: 0.5, flex: 1 },
    titleText: { fontWeight: 600 },
    description: { mt: 0.5, fontSize: '0.875rem', lineHeight: 1.5, opacity: 0.85 },
    footerBox: { px: 1.5, pb: 1 },
    subTitle: { fontSize: '0.72rem', color: palette.headerColor, opacity: 0.8 }
  }
})

const BarHeader = ({ styles, t, palette }) => (
  <Paper elevation={2} square>
    <Grid container sx={styles.header.grid}>
      <Grid item xs={3} sx={styles.header.iconCol}>
        <BartenderIcon sx={{ fontSize: 48, color: palette.headerColor }} />
      </Grid>
      <Grid item xs={9} sx={styles.header.contentCol}>
        <Typography variant="subtitle1" fontWeight={700} sx={styles.header.title}>
          {t('on-bar')}
        </Typography>
      </Grid>
    </Grid>
  </Paper>
)

const BarCard = ({ data, styles }) => {
  const { titles, sub_titles, descriptions, order } = data
  return (
    <MuiCard sx={{ width: '100%', mb: '4px' }}>
      <Grid container sx={{ minHeight: '80px' }}>
        <Grid item xs={3} sx={styles.card.leftCol}>
          <Box sx={styles.card.leftIconWrapper}>
            <SportsBarIcon sx={styles.card.leftIcon} />
            <Typography sx={styles.card.leftNumber}>{order}</Typography>
          </Box>
        </Grid>
        <Grid item xs={9} sx={styles.card.rightCol}>
          <Box sx={styles.card.bodyBox}>
            <TranslatableTypography variant="body2" sx={styles.card.titleText} data={titles} />
            <TranslatableTypography sx={styles.card.description} data={descriptions} />
          </Box>
          <Box sx={styles.card.footerBox}>
            <TranslatableTypography sx={styles.card.subTitle} data={sub_titles} />
          </Box>
        </Grid>
      </Grid>
    </MuiCard>
  )
}

export const Bar = ({ data, loading }) => {
  const { t } = useTranslation()
  const { palette } = useThemeMode()
  const styles = makeStyles(palette)

  if (loading && notDefined(data)) return undefined
  if (notDefined(data)) return <Box><NoData /></Box>

  return (
    <Box>
      <BarHeader styles={styles} t={t} palette={palette} />
      <Box sx={styles.list}>
        {data.map((item, i) => <BarCard key={i} data={item} styles={styles} />)}
      </Box>
    </Box>
  )
}
